import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 380px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#9A95B0'};
`;

export const NodeContext = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  background: ${({ theme: { colors = {} } }) =>
    colors.surfaceContainerLowest ?? '#07080F'};
  border: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#25263A'};
  border-radius: ${({ theme: { borderRadius = {} } }) =>
    borderRadius.small ?? '6px'};
`;

export const NodeLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};
`;

export const Instructions = styled.div`
  font-size: 12px;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#9A95B0'};
  line-height: 1.5;
  white-space: pre-wrap;
`;

export const Explanation = styled.div`
  font-size: 12px;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#9A95B0'};
  line-height: 1.5;
`;

export const OutputRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background: ${({ theme: { colors = {} } }) =>
    colors.surfaceContainerLowest ?? '#07080F'};
  border: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#25263A'};
  border-radius: ${({ theme: { borderRadius = {} } }) =>
    borderRadius.small ?? '6px'};
`;

export const OutputPortLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};
`;

export const FilePickerLabel = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: ${({ theme: { borderRadius = {} } }) =>
    borderRadius.small ?? '6px'};
  border: 1px solid
    ${({ theme: { colors = {} } }) => colors.outline ?? '#3A3B52'};
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  &:focus-within {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
`;

export const SelectedFileName = styled.span`
  font-size: 12px;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#9A95B0'};
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EmptyHint = styled.div`
  font-size: 12px;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#9A95B0'};
  font-style: italic;
`;
